import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useRecruitment = () => {
  const [applicants, setApplicants] = useState(null);

  useEffect(() => {
    axios.get(`${API}/recruitment`, { withCredentials: true })
      .then((res) => setApplicants(res.data))
      .catch(() => setApplicants([]));
  }, []);

  return applicants;
};
